import { createClient, type SupabaseClient } from '@supabase/supabase-js';

/**
 * Client Supabase — lit la config depuis les variables d'env Vite.
 * Les valeurs sont publiques (le anon key est conçu pour être exposé côté client,
 * la sécurité repose sur les policies RLS en base).
 *
 * Config à remplir dans app/.env (voir .env.example).
 */
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    console.warn(
        '[Supabase] Variables manquantes dans .env : VITE_SUPABASE_URL et/ou VITE_SUPABASE_ANON_KEY.\n' +
        'Copie app/.env.example vers app/.env et remplis les valeurs depuis le dashboard Supabase ' +
        '(Project Settings → API).'
    );
}

export const supabase: SupabaseClient = createClient(
    supabaseUrl ?? 'https://placeholder.supabase.co',
    supabaseAnonKey ?? 'placeholder-anon-key',
    {
        auth: {
            persistSession: true,
            autoRefreshToken: true,
            detectSessionInUrl: true,
        },
    }
);
